import {
  getIsoWeekInfo,
  nextIsoWeek,
  normalizeDateStartInput,
  weekDateBounds,
} from '~/utils/isoWeek';

export const RELATIVE_ISO_WEEK_TABS = [
  { id: 'past', label: 'Прошлая', shortLabel: 'Прошл.' },
  { id: 'active', label: 'Текущая неделя' },
  { id: 'next', label: 'Следующая', shortLabel: 'След.' },
];

function formatTodayYmd() {
  return new Date().toISOString().slice(0, 10);
}

function previousIsoWeek(isoYear, isoWeek) {
  const bounds = weekDateBounds(isoYear, isoWeek);
  const previousMonday = new Date(`${bounds.dateStart}T00:00:00.000Z`);
  previousMonday.setUTCDate(previousMonday.getUTCDate() - 7);
  const info = getIsoWeekInfo(previousMonday.toISOString().slice(0, 10));
  return info ? { isoYear: info.isoYear, isoWeek: info.isoWeek } : null;
}

export function resolveDefaultSelectedWeekBounds() {
  const info = getIsoWeekInfo(formatTodayYmd());
  if (!info) {
    return null;
  }

  const bounds = weekDateBounds(info.isoYear, info.isoWeek);
  return {
    isoYear: info.isoYear,
    isoWeek: info.isoWeek,
    dateStart: bounds.dateStart,
    dateEnd: bounds.dateEnd,
  };
}

export function resolveSelectedWeekBoundsFromYmd(ymd) {
  const normalized = normalizeDateStartInput(ymd);
  if (!normalized) {
    return null;
  }

  const info = getIsoWeekInfo(normalized);
  if (!info) {
    return null;
  }

  const bounds = weekDateBounds(info.isoYear, info.isoWeek);
  return {
    isoYear: info.isoYear,
    isoWeek: info.isoWeek,
    dateStart: bounds.dateStart,
    dateEnd: bounds.dateEnd,
  };
}

export function resolveInitialSelectedWeekBoundsFromRouteQuery(weekDateRaw) {
  const raw = Array.isArray(weekDateRaw) ? weekDateRaw[0] : weekDateRaw;
  const bounds = resolveSelectedWeekBoundsFromYmd(raw);
  if (bounds) {
    return bounds;
  }

  return resolveDefaultSelectedWeekBounds();
}

export function shiftSelectedWeekBounds(bounds, direction) {
  if (!bounds?.isoYear || !bounds?.isoWeek) {
    return resolveDefaultSelectedWeekBounds();
  }

  const shifted = direction < 0
    ? previousIsoWeek(bounds.isoYear, bounds.isoWeek)
    : nextIsoWeek(bounds.isoYear, bounds.isoWeek);
  if (!shifted) {
    return bounds;
  }

  const nextBounds = weekDateBounds(shifted.isoYear, shifted.isoWeek);
  return {
    isoYear: shifted.isoYear,
    isoWeek: shifted.isoWeek,
    dateStart: nextBounds.dateStart,
    dateEnd: nextBounds.dateEnd,
  };
}

export function weekBoundsMatch(left, right) {
  return Boolean(
    left?.isoYear === right?.isoYear
    && left?.isoWeek === right?.isoWeek,
  );
}

export function resolveRelativeIsoWeekNavBounds(referenceBounds = null) {
  const current = referenceBounds || resolveDefaultSelectedWeekBounds();
  if (!current) {
    return {};
  }

  return {
    past: shiftSelectedWeekBounds(current, -1),
    active: current,
    next: shiftSelectedWeekBounds(current, 1),
  };
}

export function countIsoWeekOffset(fromBounds, toBounds) {
  if (!fromBounds?.dateStart || !toBounds?.dateStart) {
    return null;
  }

  const fromMs = Date.parse(`${fromBounds.dateStart}T00:00:00.000Z`);
  const toMs = Date.parse(`${toBounds.dateStart}T00:00:00.000Z`);
  if (!Number.isFinite(fromMs) || !Number.isFinite(toMs)) {
    return null;
  }

  return Math.round((toMs - fromMs) / (7 * 86400000));
}

export function resolveActiveRelativeIsoWeekTabId(selectedBounds, relativeBounds = null) {
  const bounds = selectedBounds;
  const relative = relativeBounds || resolveRelativeIsoWeekNavBounds();

  if (weekBoundsMatch(bounds, relative.past)) {
    return 'past';
  }
  if (weekBoundsMatch(bounds, relative.active)) {
    return 'active';
  }
  if (weekBoundsMatch(bounds, relative.next)) {
    return 'next';
  }

  return '';
}

export function resolveIsoWeekRelativeEyebrowLabel(bounds) {
  if (!bounds?.dateStart || !bounds?.dateEnd) {
    return 'Текущая неделя';
  }

  const today = formatTodayYmd();
  if (bounds.dateStart <= today && today <= bounds.dateEnd) {
    return 'Текущая неделя';
  }
  if (bounds.dateEnd < today) {
    return 'Прошедшая неделя';
  }
  return 'Будущая неделя';
}
